import React from "react"

const Card = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div ref={ref} className={`card ${className}`} {...props}>
    {children}
  </div>
))
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div ref={ref} className={`card-header ${className}`} {...props}>
    {children}
  </div>
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <h3 ref={ref} className={`card-title ${className}`} {...props}>
    {children}
  </h3>
))
CardTitle.displayName = "CardTitle"

const CardContent = React.forwardRef(({ className = "", children, ...props }, ref) => (
  <div ref={ref} className={`card-content ${className}`} {...props}>
    {children}
  </div>
))
CardContent.displayName = "CardContent"

export { Card, CardHeader, CardTitle, CardContent }
